import { render } from "./FolderMultiple.vue?vue&type=template&id=57cab5ec"
import script from "./FolderMultiple.vue?vue&type=script&lang=js"
export * from "./FolderMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__